import * as Redux from 'redux';
import { AppState, buildEnhancer, configureStore as baseConfigureStore } from 'acscp/store';
import { rootReducer } from 'acscp/reducers';
import { statePersistor, stateRehydrator } from './statePersistanceHelper';

function buildReducer(): Redux.Reducer<AppState> {
    return stateRehydrator(rootReducer);
}

function getEnhancerComposer(): (...args: Redux.StoreEnhancer[]) => Redux.StoreEnhancer {
    if (process.env.NODE_ENV !== 'development') {
        return Redux.compose;
    }

    return (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || Redux.compose;
}

export function configureStore(): Redux.Store<AppState> {
    const reducer = buildReducer();
    const composer = getEnhancerComposer();
    return baseConfigureStore(reducer, buildEnhancer(composer, statePersistor));
}
